import Vue from 'vue';
import VueNativeSock from 'vue-native-websocket'
import {store} from "../vuex";

Vue.use(VueNativeSock, 'ws://localhost:9090', {
  store: store,
  connectManually: true,
  format: 'json',
  reconnection: true, // (Boolean) whether to reconnect automatically (false)
  // reconnectionAttempts: 5, // (Number) number of reconnection attempts before giving up (Infinity),
  reconnectionDelay: 300, // (Number) how long to initially wait before attempting a new (1000)
});
